import { render, staticRenderFns } from "./employe-list-item.vue?vue&type=template&id=08e1bc84&scoped=true"
import script from "./employe-list-item.vue?vue&type=script&lang=js"
export * from "./employe-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e1bc84",
  null
  
)

export default component.exports